export const tableColumns = [
    {
        name: "salesFakturDate",
        label: "Tanggal Faktur Jual",
    },
    {
        name: "salesFakturNo",
        label: "Nomor Faktur Jual",
    },
    {
        name: "bookNo",
        label: "No. Buku",
    },
    {
        name: "variant.kodeVariant",
        label: "Kode Varian",
    },
    {
        name: "variant.namaVariant",
        label: "Nama Varian",
    },
    {
        name: "warna.kodeWarna",
        label: "Kode Warna",
    },
    {
        name: "warna.namaWarnaKomersil",
        label: "Nama Warna",
    },
    {
        name: "stnkName",
        label: "Nama STNK",
    },
    {
        name: "customerName",
        label: "Nama Pembeli",
    },
    {
        name: "frameNumber",
        label: "Nomor Rangka",
    },
    {
        name: "engineNumber",
        label: "Nomor Mesin",
    },
];

export const tableColumns1 = [
    {
        name: "salesFakturDate",
        label: "Tanggal Faktur Jual",
    },
    {
        name: "salesFakturNo",
        label: "Nomor Faktur Jual",
    },
    {
        name: "bookNo",
        label: "No. Buku",
    },
    {
        name: "ssuDate",
        label: "Tanggal Pengajuan",
    },
    {
        name: "submitterName",
        label: "Pengaju",
    },
    {
        name: "receivedSSUDate",
        label: "Tanggal Diterima",
    },
    {
        name: "recipientName",
        label: "Penerima",
    },
    {
        name: "variant.kodeVariant",
        label: "Kode Varian",
    },
    {
        name: "variant.namaVariant",
        label: "Nama Varian",
    },
    {
        name: "warna.kodeWarna",
        label: "Kode Warna",
    },
    {
        name: "warna.namaWarnaKomersil",
        label: "Nama Warna",
    },
    {
        name: "stnkName",
        label: "Nama STNK",
    },
    {
        name: "customerName",
        label: "Nama Pembeli",
    },
    {
        name: "frameNumber",
        label: "Nomor Rangka",
    },
    {
        name: "engineNumber",
        label: "Nomor Mesin",
    },
    {
        name: "ssuStatus",
        label: "Status",
    },
];

export const formGroup = {
    ssuId: {value: ""},
    orderH1: {value: ""},
    ssuDate: {value: ""},
    submitterName: {value: ""},
    recipientName: {value: ""},
    salesFakturNo: {value: ""},
    salesFakturDate: {value: ""},
    bookNo: {value: ""},
    kodeVariant: {value: ""},
    kodeWarna: {value: ""},
    stnkName: {value: ""},
    customerName: {value: ""},
    engineNumber: {value: ""},
    frameNumber: {value: ""},
    fakturNo: {value: "", mandatory: true},
    photoSSU: {value: ""},
    photoSSUUrl: {value: ""},
    ssuStatus: {value: ""},
    kodeCabang: {value: ""},
};
